<template>
  <c-box>
    <c-box
      v-for="service in serviceproducts"
      :key="service.category"
      :border-radius="{ md: 'base' }"
      background="white"
      :box-shadow="{ md: 'base' }"
      :mx="{ base: '-31px', md: '0' }"
    >
      <c-box
        :px="{ base: 'md', sm: '2xl', lg: '5rem' }"
        :py="{ base: 'md', sm: '3xl', lg: '3rem' }"
        :mb="{ base: 'md', md: '3xl' }"
      >
        <c-flex flexDirection="column">
          <ASProductRadioSelect
            :additionalService="service"
            :round="round"
            :isProductInShoppingCart="isProductInShoppingCart"
            :onDisabledInputSelection="onDisabledInputSelection"
          />
        </c-flex>
      </c-box>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { CBox, CDivider, CFlex } from "@chakra-ui/vue";
import { IOrderRow, IServiceproduct, ICartState } from "@iloq/shared";
import { round } from "lodash";
import { defineComponent, PropType } from "vue";
import i18n from "../../i18n";
import ASProductRadioSelect from "./ASProductRadioSelect.vue";

export default defineComponent({
  name: "AdditionalServices",
  components: {
    CBox,
    CFlex,
    CDivider,
    ASProductRadioSelect,
  },
  props: {
    isUserPermittedToOrderServiceProducts: Boolean,
    cart: { type: Object as PropType<ICartState>, required: true },
    partnerInfo: Object as PropType<any>,
    // FIXME: IAdditionalService does not contain category
    // serviceproducts: Object as PropType<{ [key: string]: IAdditionalService }>,
    serviceproducts: Object as PropType<any>,
  },
  methods: {
    onDisabledInputSelection(products: IServiceproduct[]): void {
      if (products.find(({ orderingAllowed }) => !orderingAllowed)) {
        this.$store.commit(
          "showGeneralError",
          {
            dialogTitle: i18n.t("shoppingCart.orderingNotAllowedDialog.title"),
            dialogText: i18n.t("shoppingCart.orderingNotAllowedDialog.body"),
          },
          {
            root: true,
          },
        );
      }
    },
    isProductInShoppingCart(product: IServiceproduct): boolean {
      return (this.cart.cartRows as IOrderRow[]).some((row) => row.product.id === product.id);
    },
    round(number: number, precision: number): number {
      return round(number, precision ?? 0);
    },
  },
});
</script>
